// extracted by mini-css-extract-plugin
export default {"reactMarkDown":"markdown_reactMarkDown__8ASok"};